import { useCallback, useEffect } from 'react';
import {
  LeasingCalculatorCodesSelectors,
  LeasingCalculatorCodesThunks,
} from './redux/leasingCalculatorCodes';
import { useAppDispatch, useAppSelector } from '../appHooks';

export const useLeasingCalculatorCodes = () => {
  const dispatch = useAppDispatch();

  const leasingRecipientTypes = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingRecipientTypes,
  );

  const leasingRecipientTypesOptions = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingRecipientTypesOptions,
  );

  const leasingTypes = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingTypes,
  );

  const leasingTypesOptions = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingTypesOptions,
  );

  const leasingObjectSuppliers = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingObjectSuppliers,
  );

  const leasingObjectSuppliersOptions = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingObjectSuppliersOptions,
  );

  const leasingCurrencies = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingCurrencies,
  );

  const leasingCurrenciesOptions = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingCurrenciesOptions,
  );

  const leasingTaxRates = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingTaxRateCodes,
  );

  const leasingTaxRateCodesOptions = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingTaxRateCodesOptions,
  );

  const paymentPeriodTypes = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingPaymentPeriodTypes,
  );

  const paymentPeriodTypesOptions = useAppSelector(
    LeasingCalculatorCodesSelectors.selectLeasingPaymentPeriodTypesOptions,
  );

  const financingPeriods = useAppSelector(
    LeasingCalculatorCodesSelectors.selectFinancingPeriods,
  );

  const financingPeriodsOptions = useAppSelector(
    LeasingCalculatorCodesSelectors.selectFinancingPeriodsOptions,
  );

  useEffect(() => {
    if (
      !leasingTaxRateCodesOptions ||
      !financingPeriodsOptions ||
      !paymentPeriodTypesOptions
    ) {
      dispatch(LeasingCalculatorCodesThunks.fetchLeasingCalculatorCodes());
    }
  }, [
    dispatch,
    financingPeriodsOptions,
    leasingTaxRateCodesOptions,
    paymentPeriodTypesOptions,
  ]);

  useEffect(() => {
    if (
      !leasingRecipientTypesOptions ||
      !leasingTypesOptions ||
      !leasingObjectSuppliersOptions ||
      !leasingCurrenciesOptions
    ) {
      dispatch(
        LeasingCalculatorCodesThunks.fetchLeasingCalculatorGeneralDataCodes(),
      );
    }
  }, [
    dispatch,
    leasingCurrenciesOptions,
    leasingObjectSuppliersOptions,
    leasingRecipientTypesOptions,
    leasingTypesOptions,
  ]);

  const findLeasingTypeByName = useCallback(
    (leasingType: string) =>
      leasingTypes?.find((type) => type.name === leasingType),
    [leasingTypes],
  );

  const findLeasingCurrencyByName = useCallback(
    (name: string) => leasingCurrencies?.find((curr) => curr.name === name),
    [leasingCurrencies],
  );

  return {
    leasingRecipients: {
      uwtTypes: leasingRecipientTypes ?? [],
      options: leasingRecipientTypesOptions ?? [],
    },
    leasingTypes: {
      uwtTypes: leasingTypes ?? [],
      options: leasingTypesOptions ?? [],
    },
    leasingObjectSuppliers: {
      uwtTypes: leasingObjectSuppliers ?? [],
      options: leasingObjectSuppliersOptions ?? [],
    },
    leasingCurrencies: {
      uwtTypes: leasingCurrencies ?? [],
      options: leasingCurrenciesOptions ?? [],
    },
    financingPeriods: {
      uwtTypes: financingPeriods ?? [],
      options: financingPeriodsOptions ?? [],
    },
    paymentPeriodTypes: {
      uwtTypes: paymentPeriodTypes ?? [],
      options: paymentPeriodTypesOptions ?? [],
    },
    leasingTaxRates: {
      uwtTypes: leasingTaxRates ?? [],
      options: leasingTaxRateCodesOptions ?? [],
    },
    findLeasingTypeByName,
    findLeasingCurrencyByName,
  };
};
